/** SidebarPage.jsx */
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo PNG Transparent/Logo-09.png';
import home from '../assets/home.png';
import test from '../assets/search-status.png';
import results from '../assets/results.png';
import profile from '../assets/medal-star11.png';
import setting from '../assets/setting.png';
import logout from '../assets/logout.png';
import usersIcon from '../assets/Communication.png';
import testsIcon from '../assets/book frame.png';
import communicationIcon from '../assets/code and measurement.png';

const Sidebar = ({ isOpen, onClose }) => {
  const [selected, setSelected] = useState('dashboard');
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout: authLogout, user } = useAuth();

  const currentPath = location.pathname;

  useEffect(() => {
    if (currentPath.includes('/admin/communication')) setSelected('Communication');
    else if (currentPath.includes('/admin/tests')) setSelected('TestsManagement');
    else if (currentPath.includes('/admin/users')) setSelected('UserManagement');
    else if (currentPath.includes('/dashboard')) setSelected('dashboard');
    else if (currentPath.includes('/test-results') || currentPath.includes('/results')) setSelected('results');
    else if (currentPath.includes('/profile')) setSelected('profile');
    else if (currentPath.includes('/personality-test') || currentPath.includes('/test')) setSelected('test');
  }, [currentPath]);

  const handleLogout = () => {
    try {
      // Use AuthContext logout function
      authLogout();
      setShowConfirmLogout(false);
    } catch (error) {
      console.error('Error during logout:', error);
      // Even if there's an error, try to navigate away
      navigate('/');
    }
  };

  const showLogoutConfirmation = () => {
    setShowConfirmLogout(true);
  };



  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="w-64 h-screen bg-[#F9F3FF] shadow-md flex flex-col justify-between py-4 px-3 text-[#1e1e1e] font-sans" >
          <div>
            <div className="mb-4">
              <img src={logo} alt="Logo" style={{ width: 'auto', height: '40px' }} />
            </div>

            <div className="bg-white rounded-xl p-3 flex items-center gap-3 mb-6">
              <div className="bg-orange-400 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold text-sm">
                {user ? (user.name ? user.name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase() : `${user.firstName?.charAt(0)?.toUpperCase() || ''}${user.lastName?.charAt(0)?.toUpperCase() || ''}`) : 'U'}
              </div>
              <div>
                <p className="text-sm font-semibold">
                  {user ? (user.name || `${user.firstName?.charAt(0)?.toUpperCase() || ''}${user.firstName?.slice(1)?.toLowerCase() || ''} ${user.lastName?.charAt(0)?.toUpperCase() || ''}${user.lastName?.slice(1)?.toLowerCase() || ''}`.trim() || 'User') : 'User'}
                </p>
                <p className="text-xs text-gray-500">
                  {user?.role === 'admin' ? 'Admin' : (user?.plan || 'FREE')}
                </p>
              </div>
            </div>
            <nav className="space-y-4">
              {/* <Link to="/dashboard"
                className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${currentPath === '/dashboard'
                  ? 'sidebar-selected'
                  : 'text-gray-600 hover:text-orange-500'
                  }`}
              >
                <img src={home} alt="home" className="w-6" /> Dashboard
              </Link> */}
              {user && user.role === 'user' && (
                <Link
                  to="/sevenquestion"
                  className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${currentPath === '/personality-test'
                      ? 'sidebar-selected'
                      : 'text-gray-600 hover:text-[#7A81FF]'
                    }`}
                >
                  <img src={test} alt="test" className="w-6" /> Take Test
                </Link>
              )}
{/* 
              {user && user.role === 'user' && (
                <Link
                  to="/test-results"
                  className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${currentPath === '/test-results'
                      ? 'sidebar-selected'
                      : 'text-gray-600 hover:text-green-600'
                    }`}
                >
                  <img src={results} alt="results" className="w-6" /> My Results
                </Link>
              )}
 */}

              {user?.role === 'admin' && (
                <>
                  <Link to="/admin/users"
                    onClick={() => setSelected('UserManagement')}
                    className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${selected === 'UserManagement'
                      ? 'sidebar-selected'
                      : 'text-gray-600 hover:text-blue-600'
                      }`}
                  >
                    <img src={usersIcon} alt="profile" className="w-6" /> User Management
                  </Link>
                  <Link to="/admin/tests"
                    onClick={() => setSelected('TestsManagement')}
                    className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${selected === 'TestsManagement'
                      ? 'sidebar-selected'
                      : 'text-gray-600 hover:text-blue-600'
                      }`}
                  >
                    <img src={testsIcon} alt="profile" className="w-6" /> Tests Management
                  </Link>
                  <Link to="/admin/communication"
                    onClick={() => setSelected('Communication')}
                    className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${selected === 'Communication'
                      ? 'sidebar-selected'
                      : 'text-gray-600 hover:text-blue-600'
                      }`}
                  >
                    <img src={communicationIcon} alt="profile" className="w-5" /> Communication
                  </Link>
                </>
              )}

              <Link to="/profile"
                onClick={() => setSelected('profile')}
                className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer ${selected === 'profile'
                  ? 'sidebar-selected'
                  : 'text-gray-600 hover:text-blue-600'
                  }`}
              >
                <img src={profile} alt="profile" className="w-6" /> Profile
              </Link>
            </nav>
          </div>

          <div>

            <div onClick={showLogoutConfirmation} className="flex items-center gap-2 text-sm text-gray-500 hover:text-red-500 cursor-pointer mt-4 px-3 py-2 rounded hover:bg-red-50 transition-colors">
              <img src={logout} alt="logout" className="w-6" /> Logout
            </div>
          </div>
        </div>

        {/* Custom CSS styles */}
        <style>{`
        .sidebar-selected {
          background-color: #fff;
          color: #7A81FF !important;
          font-weight: 600;
        }

        .sidebar-selected img {
          filter: brightness(0) saturate(100%) invert(71%) sepia(3%) saturate(221%) hue-rotate(169deg) brightness(93%) contrast(89%);
        }
      `}</style>
      </div>
      {showConfirmLogout && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-40"
            onClick={() => setShowConfirmLogout(false)}
          />
          <div className="relative bg-white rounded-lg shadow-lg w-80 p-5 z-[61]">
            <h3 className="text-base font-semibold mb-2">Are you sure you want to logout?</h3>
            <p className="text-sm text-gray-600 mb-4">You will need to login again to continue.</p>
            <div className="flex justify-end gap-2">
              <button
                className="px-4 py-2 text-sm rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
                onClick={() => setShowConfirmLogout(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-sm rounded text-white bg-red-500 hover:bg-red-600"
                onClick={handleLogout}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;